module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cancelation-policy.json
// module id = 367
// module chunks = 19530477033950